// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "assistant_usage".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "assistant_usage" table (1:1 with a DB row, on the wire). */
export const assistantUsageAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    date: z.string(),
    messageCount: z.number(),
});
//# sourceMappingURL=assistantUsage.js.map